import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import Logo from "../assets/images/PAYLOFT_LOGO.png";
import { useAuth } from "../context/AuthContextProvider";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [inputPassNew, setInputPassNew] = useState("password");
  const [showNew, setShowNew] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);


  const getTenantFromUrl = () => {
    const { hostname } = window.location;

    // Remove www.
    const cleanHost = hostname.replace(/^www\./, "");

    // Get first domain part (before .com, .co.uk, etc.)
    const domainPart = cleanHost.split(".")[0];

    // Extract tenant before first "-"
    const tenant = domainPart.split("-")[0];

    if (!tenant || ["localhost", "admin", "payloft"].includes(tenant.toLowerCase())) {
      return null;
    }
    return tenant;
  };

  const tenant = getTenantFromUrl();

  const navigate = useNavigate();
  const { login, loading } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      if (email !== "" && password !== "") {
        await login(email, password, tenant);
      }
    } catch (error) {
      throw error;
    }
  };

  const handleShowNew = (e) => {
    e.preventDefault();
    setShowNew(!showNew);
    setInputPassNew(inputPassNew === "password" ? "text" : "password");
  };

  // Load email and password from localStorage on component mount
  // useEffect(() => {
  //   const storedEmail = localStorage.getItem("rememberedEmail");
  //   const storedPassword = localStorage.getItem("rememberedPassword");
  //   if (storedEmail && storedPassword) {
  //     setEmail(storedEmail);
  //     const decryptedPassword = decryptPassword(storedPassword);
  //     setPassword(decryptedPassword);
  //     setRememberMe(true);
  //   }
  // }, []);

  // // Save email and password to localStorage when "Remember Me" is checked
  // useEffect(() => {
  //   if (rememberMe) {
  //     localStorage.setItem("rememberedEmail", email);
  //     const encryptedPassword = encryptPassword(password);
  //     localStorage.setItem("rememberedPassword", encryptedPassword);
  //   } else {
  //     localStorage.removeItem("rememberedEmail");
  //     localStorage.removeItem("rememberedPassword");
  //   }
  // }, [rememberMe, email, password]);

  // const encryptPassword = (value) => {
  //   return CryptoJS.AES.encrypt(value, "secretkey123").toString();
  // };

  // const decryptPassword = (encryptedValue) => {
  //   const bytes = CryptoJS.AES.decrypt(encryptedValue, "secretkey123");
  //   return bytes.toString(CryptoJS.enc.Utf8);
  // };

  return (
    <div className="flex justify-center">
      <div className="w-[375px] p-4">
        <div className="flex items-center justify-center">
          <img
            src={window.__TENANT__?.logo ?? Logo}
            alt="logo"
            className="w-[150px] h-auto"
          />
        </div>
        <h1 className="text-[25px] font-semibold border-b pb-14 text-center">
          Login
        </h1>
        <div className="flex flex-col">
          <form onSubmit={handleLogin}>
            <div className="flex flex-col mt-8">
              {/* <label htmlFor="email">Email Address</label> */}
              <input
                type="email"
                id="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-0 
             focus:shadow-[0_0_10px_rgba(251,146,60,0.8)] h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                required
              />
            </div>
            <div className="flex flex-col mt-8 relative">
              {/* <label htmlFor="password">Password</label> */}
              <button
                type="button"
                onClick={handleShowNew}
                className="absolute right-4 top-7"
                tabIndex={-1}
              >
                {showNew ? <FaEyeSlash /> : <FaEye />}
              </button>
              <input
                type={inputPassNew}
                id="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-0 
             focus:shadow-[0_0_10px_rgba(251,146,60,0.8)] h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                required
              />
            </div>
            <div className="flex items-center justify-between mt-6">
              {/* <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <p>Remember me</p>
              </div> */}
              <div>
                <div
                  className="text-text-orange cursor-pointer"
                  onClick={() => navigate("/reset-password")}
                >
                  Reset Password?
                </div>
              </div>
            </div>
            <div className="mt-10">
              <button
                disabled={loading}
                className={`relative flex items-center justify-center w-[348px] h-[50px] rounded-md text-white font-medium overflow-hidden transition-all duration-300 ${loading
                  ? "bg-primary cursor-not-allowed"
                  : "bg-primary hover:bg-[rgba(var(--primary-rgb),0.7)]"
                  }`}
                type="submit"
              >
                {loading ? (
                  <span className="relative flex items-center gap-2">
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      ></path>
                    </svg>
                    <span className="text-white">Logging in...</span>
                    <span className="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-white/20 to-transparent"></span>
                  </span>
                ) : (
                  "Login"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
